module.exports = __webpack_public_path__ + "static/media/stopwatch.f25a1c38.svg";